// 工具页面状态管理
const state = {
  currentTool: null,
  animationStates: {},
  userPreferences: {
    autoPlay: true,
    showThumbnails: true,
    animationSpeed: 1.0
  },
  scrollTriggers: {},
  loadedAnimations: new Set()
}

const mutations = {
  SET_CURRENT_TOOL(state, tool) {
    state.currentTool = tool
  },
  SET_ANIMATION_STATE(state, { id, state: animationState }) {
    state.animationStates[id] = animationState
  },
  SET_USER_PREFERENCE(state, { key, value }) {
    state.userPreferences[key] = value
  },
  SET_SCROLL_TRIGGER(state, { elementId, isVisible }) {
    state.scrollTriggers[elementId] = isVisible
  },
  ADD_LOADED_ANIMATION(state, animationId) {
    state.loadedAnimations.add(animationId)
  }
}

const actions = {
  setCurrentTool({ commit }, tool) {
    commit('SET_CURRENT_TOOL', tool)
  },
  updateAnimationState({ commit }, { id, state }) {
    commit('SET_ANIMATION_STATE', { id, state })
  },
  updateUserPreference({ commit }, { key, value }) {
    commit('SET_USER_PREFERENCE', { key, value })
  },
  setScrollTrigger({ commit }, { elementId, isVisible }) {
    commit('SET_SCROLL_TRIGGER', { elementId, isVisible })
  },
  markAnimationLoaded({ commit }, animationId) {
    commit('ADD_LOADED_ANIMATION', animationId)
  }
}

const getters = {
  currentTool: state => state.currentTool,
  animationState: state => id => state.animationStates[id],
  userPreferences: state => state.userPreferences,
  scrollTrigger: state => elementId => state.scrollTriggers[elementId],
  isAnimationLoaded: state => animationId => state.loadedAnimations.has(animationId)
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} 